import { Component, Input, ChangeDetectorRef } from "@angular/core";
import { BaseControlComponent } from "../base/base-control.component";
import { SelectorService } from "../base/selector.service";
@Component({
  selector: "ssg-menu",
  templateUrl: "menu.component.html",
  styleUrls: ["menu.component.scss"],
})
export class SepidzMenuComponent extends BaseControlComponent<string> {
  @Input() icon: string;
  @Input() appearance: string;
  @Input() size: string;
  @Input() up: boolean;
  top: string;
  left: string;
  right: string;
  openToggle: boolean;

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
    if (!this.icon && !this.label) this.icon = "icon-more_vert-o";
  }
  close() {
    setTimeout(() => {
      if (this.openToggle) this.openToggle = false;
      this.cd.markForCheck();
    }, 200);
  }
  openPopOver() {
    this.openToggle = !this.openToggle;
    this.cd.markForCheck();
  }
}
